<template>
  <div class="wrapper">
    <div class="wrapper__header">
      <Logo />
      <SearchNews :newspaper="newspaper"/>
    </div>
    <Hostspot
      v-if="defaultList"
      :pageNewsArea="pageNewsArea"
      :newspaper="newspaper"
      :pageInfo="pageInfo"
      :swiperIndex="swiperIndex"
      :defaultList="defaultList"
      @changeIndex="getHotspotIndex"
      @changeHotspot="changeHotspot"
    />
  </div>
  <Periodical v-if="periodical == 1  || periodical == 4" :newspaper="newspaper" :swiperIndex="swiperIndex" :newspaperId="newspaperId" @emit-content="getDailyPageList"/>
  <School v-else-if="periodical == 5" @emit-home="getDailyPageList" :newspaperId="newspaperId" :swiperIndex="swiperIndex"/>
  <Daily v-else @emit-home="getDailyPageList" :newspaperId="newspaperId" :swiperIndex="swiperIndex"/>
  <router-view></router-view>
</template>
<script>
import Daily from '../components/Daily'
import Periodical from '../components/Periodical'
import School from '../components/School'
import Logo from './Logo'
import SearchNews from '../search/SearchNews'
import Hostspot from './Hotspot'
import { ref, watch, computed } from 'vue'
import { useStore } from 'vuex'
import { get } from '../../utils/request'
import { useRoute } from 'vue-router'
export default {
  name: 'Home',
  components: { School, Periodical, Daily, Logo, Hostspot, SearchNews },
  setup () {
    const newspaperId = ref('')
    const newspaper = ref('')
    const periodical = ref()
    const swiperIndex = ref(0)
    const pageInfo = ref({})
    const pageNewsArea = ref([])
    const pageData = ref({})
    const newsId = ref()
    const cname = ref()
    // const showHeight = ref()
    // const imgHe ight = ref()
    const store = useStore()
    const pageList = computed(() => store.state.pageList)
    const defaultList = computed(() => store.state.defaultList)
    const router = useRoute()
    // document.title = cname.value
    // debugger
    newspaper.value = router.params.accessName
    store.dispatch('getNewspaper', newspaper.value)
    // pageNewsArea.value = JSON.parse(pageList.value.newsArea)
    // const newPageList = ref({
    //   id: pageList.value.id,
    //   accessName: pageList.value.accessName,
    //   outfilePath: pageList.value.outfilePath,
    //   pagePicFile: pageList.value.pagePicFile,
    //   newsArea: pageNewsArea.value
    // })
    // const getNewspaperPage = async () => {
    //   const url = `/tablePageController/getTablePage?id=${pageList.value.id}&accessName=${pageList.value.accessName}`
    //   // const url = '/tablePageController/getTablePage?id=00CE007EC8094EBAA1509DA5AD30F4A9&accessName=xlglrb'
    //   const result = await get(url)
    //   newspaperPage.value = result.data
    // }

    const getNewspaper = async () => {
      const url = `/newspaperController/getNewspaper?name=${newspaper.value}`
      const result = await get(url)
      newspaperId.value = result.data.id
      periodical.value = result.data.periodical
      cname.value = result.data.cname
      store.dispatch('getPeriodical', periodical.value)
      store.dispatch('getNewspaperId', newspaperId.value)
    }
    getNewspaper()
    const getDailyPageList = (data) => {
      swiperIndex.value = data.index
      pageInfo.value = data
      pageNewsArea.value = JSON.parse(pageInfo.value.newsArea)
      store.dispatch('getSwiperIndex', swiperIndex)
    }
    const getHotspotIndex = (index) => {
      store.dispatch('getSwiperIndex', index)
    }
    const changeHotspot = (data) => {
      newsId.value = data
    }
    watch(
      () => cname.value,
      () => {
        document.title = cname.value
      }
    )
    watch(
      () => pageList,
      (val, prevVal) => {
        pageInfo.value = pageList.value
        pageNewsArea.value = JSON.parse(pageInfo.value.newsArea)
      }
    )
    return {
      pageInfo,
      pageList,
      pageData,
      newspaper,
      newspaperId,
      pageNewsArea,
      periodical,
      swiperIndex,
      defaultList,
      getNewspaper,
      getDailyPageList,
      getHotspotIndex,
      changeHotspot
    }
  }
}

</script>
<style lang="scss" scoped>
.wrapper {
  &__header{
    display: flex;
    height: 1.2rem;
    &__search{
      width: 5.4rem;
    }
  }
}

</style>
